import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { Modal, ModalHeader } from './ui';
import { DLG } from './dialogStyles';
import Avatar from './Avatar';
import { fetchRoster } from '../data/api';

/* Pick one student from the class roster (2026-10-06). Buffy's chat opens this
   when a teacher asks for something like "reset a student's password" without
   naming the student; the chosen student then goes to that action's own dialog.
   Search matches name or email. */
export default function StudentPickerModal({ auth, classId, title, sub, onPick, onClose }) {
  const [students, setStudents] = useState(null);
  const [failed, setFailed] = useState(false);
  const [query, setQuery] = useState('');
  useEffect(() => {
    let alive = true;
    fetchRoster(auth, classId)
      .then((list) => { if (alive) setStudents([...(list || [])].sort((a, b) => String(a.name).localeCompare(String(b.name), undefined, { numeric: true }))); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [auth, classId]);
  const q = query.trim().toLowerCase();
  const shown = (students || []).filter((s) => !q || String(s.name || '').toLowerCase().includes(q) || String(s.email || '').toLowerCase().includes(q));
  return (
    <Modal open onClose={onClose} size="sm">
      <ModalHeader title={title} sub={sub || 'Pick a student'} pad={DLG.head} onClose={onClose} />
      <div className="px-[24px] pt-[16px]">
        <label className="flex items-center gap-2 h-10 px-[12px] rounded-[8px] ring-1 ring-inset ring-neutral-300 focus-within:ring-ink">
          <Search size={15} className="text-neutral-400 flex-none" aria-hidden="true" />
          <input
            autoFocus
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Find a student…"
            aria-label="Find a student"
            className="flex-1 min-w-0 border-0 outline-none text-[14px] text-ink bg-transparent"
          />
        </label>
      </div>
      <div className="px-[24px] pt-[8px] pb-[16px] max-h-[320px] overflow-y-auto">
        {failed && <p className="m-0 py-[12px] text-[13px] text-error-600">Couldn&apos;t load this class&apos;s students. Try again in a moment.</p>}
        {!failed && !students && <p className="m-0 py-[12px] text-[13px] text-neutral-500">Loading students…</p>}
        {students && !shown.length && <p className="m-0 py-[12px] text-[13px] text-neutral-500">No students match.</p>}
        {shown.map((s) => (
          <button
            key={s.userId}
            type="button"
            onClick={() => onPick({ userId: s.userId, name: s.name })}
            className="w-[calc(100%+16px)] -mx-[8px] flex items-center gap-[12px] px-[8px] py-[8px] rounded-[8px] border-0 bg-transparent hover:bg-neutral-100 cursor-pointer text-left"
          >
            <Avatar name={s.name} size={28} />
            <span className="min-w-0">
              <span className="block text-[14px] font-semibold text-ink truncate">{s.name}</span>
              {s.email && <span className="block text-[12px] text-neutral-500 truncate">{s.email}</span>}
            </span>
          </button>
        ))}
      </div>
    </Modal>
  );
}
